export const updateCustomerName = (data) => ({
    type: "CustomerUpdate",
    payload: data,
})

export const updateCustomerID = (data) => ({
    type: "CUSTOMERUPDATEID",
    payload: data,
})